import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { Header } from './layout/header/header';
import { FooterComponent } from './layout/footer/footer';
import { OllamaAssistantComponent } from './shared/components/ollama-assistant/ollama-assistant.component';
import { ScrollTopComponent } from './shared/components/scroll-top/scroll-top.component';
import { WhatsappFabComponent } from './shared/components/whatsapp-fab/whatsapp-fab.component';
import { MaintenancePage } from './features/maintenance/maintenance.page';
import { environment } from '../environments/environment';
// import { PushNotificationService } from './core/services/push-notification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Header, FooterComponent, OllamaAssistantComponent, ScrollTopComponent, WhatsappFabComponent, MaintenancePage, MatSnackBarModule, MatButtonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  private swUpdate = inject(SwUpdate, { optional: true });
  private snackBar = inject(MatSnackBar);

  /** Chat bubble disabled via compile-time env flag */
  readonly disableChatBubble = environment.disableChatBubble;

  /** Full-site maintenance takeover, gated via compile-time env flag */
  readonly maintenanceMode = environment.maintenanceMode;

  ngOnInit() {
    // Service worker update notification
    this.swUpdate?.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(() => {
        const snack = this.snackBar.open('New version available!', 'Reload', {
          duration: 60000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        snack.onAction().subscribe(() => document.location.reload());
      });

    // Check for updates every 30 minutes
    setInterval(() => this.swUpdate?.checkForUpdate(), 30 * 60 * 1000);
  }
}
